<template>
  <div id="app">
    <router-view />
    <global-alert-layout v-if="lastError.exists && !lastError.handled">
      <info-box
        :msgs="lastError.msgs"
        @dispose="onDispose"
      />
    </global-alert-layout>

    <spinner v-if="asyncLoading" />
  </div>
</template>

<script>
import { log } from '@/utils/common';
import { mapGetters } from 'vuex';
import GlobalAlertLayout from '@/components/global/GlobalAlertLayout.vue';
import InfoBox from '@/components/global/InfoBox.vue';
import Spinner from '@/components/global/Spinner.vue';

export default {
  name: 'App',
  components: {
    GlobalAlertLayout,
    InfoBox,
    Spinner,
  },
  computed: {
    ...mapGetters({
      lastError: 'lastError',
      asyncLoading: 'asyncLoading',
    }),
  },
  mounted() {
    let tossSdkScript = document.createElement("script");
    tossSdkScript.setAttribute("src", "https://js.tosspayments.com/v1/connectpay");
    document.head.appendChild(tossSdkScript);
  },
  methods: {
    onDispose() {
      log('App::onDispose', 'global alert layout will be disposed..');
      this.$store.dispatch('handleLastError');
    },
  },
};
</script>

<style>
#app {
}
</style>
